/********
 *********   YouTube video autoplay
 ********/

let tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function onYouTubeIframeAPIReady() {
  window.player = new YT.Player('player', {
    events: {
      'onReady': onPlayerReady
    }
  });
}

function onPlayerReady(event) {
  window.playVideo = function() {
    clearTimeout(window.isVideoPlaying);
    window.isVideoPlaying = undefined;

    if (event.target.getPlayerState() !== 0) { // only if video hasn't played already
      event.target.playVideo();

      window.isVideoPlaying = setTimeout(() => { // after 2,5 seconds, check whether video is playing - if not, try to mute it
        if (event.target.getPlayerState() !== 1 && event.target.getPlayerState() !== 3 && event.target.getPlayerState() !== 5) { // if autoplay doesn't work, try muted
          event.target.mute();
          event.target.playVideo();
          window.isVideoPlaying = undefined;
        }
      }, 2500);
    }
  }

  window.pauseVideo = function() {
    event.target.pauseVideo();

    clearTimeout(window.isVideoPlaying);
    window.isVideoPlaying = undefined;
  }
};

/********
 *********   Go to top of the page on each refresh
 ********/
/* const goToTop = () => {
  document.querySelector('html').classList.add('jump');
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelector('html').classList.remove('jump');
}

window.onbeforeunload = goToTop;
window.onload = goToTop; */


$(document).ready(function() {

  /********
   *********   AGE VERIFICATION
   ********/

  window.adult = function (e) {
    var confirmationExpiration = new Date().getTime() + 90*60*60*24*1000; // 90 days
    window.localStorage.setItem( 'age-checker-confirmation', confirmationExpiration );

    checkAge();
    e.preventDefault();
  }

  window.underage = function (e) {
    $('.agecheck__wrap').css({ 'height': $('.agecheck__wrap').height() });
    $('.agecheck__whatage').fadeOut(700, function () {
      $('.agecheck__underage').fadeIn();
    });
    e.preventDefault();
  }

  function checkAge() {
    var now = new Date().getTime()
    if( ( window.localStorage.getItem( 'age-checker-confirmation' ) !== null
        && window.localStorage.getItem( 'age-checker-confirmation') > now ) ||
        document.referrer.includes( 'https://www.budejovickybudvar.cz/' )  ) {
      document.querySelector('html').classList.add('adult');

      //document.dispatchEvent(new Event('adultLoaded'));
      var event;
      if (typeof (Event) === 'function') {
        event = new Event('adultLoaded');
      } else {
        event = document.createEvent('Event');
        event.initEvent('adultLoaded', true, true);
      }
      document.dispatchEvent(event);

    } else {
      $('#age-verification').addClass('not-verified');
    }
  }

  checkAge();


  /********
   *********   INTRO LOADING
   ********/

  let countdown = { num: 0 },
      countdownEl = document.querySelector('.countdown__text'),
      countdownLogoEl = document.querySelector('picture.countdown__logo');

  // Fadein

  // Animate countdown to 33
  gsap.to(countdown, 3, {
    num: '+=33',
    roundProps: 'num',
    onUpdate: () => {
      countdownEl.innerHTML = countdown.num;
      if (countdown.num === 33) {

        // TODO: Display logo while assets loaded and animation loaded -> possibly use promise
        setTimeout(() => {
          document.querySelector('html').classList.add('loading--finished');

          setTimeout(() => {
            document.querySelector('html').classList.add('loaded');
          }, 1000);
        }, 1000);
      }
    },
    ease: 'power4.out'
  });




  let controller = new ScrollMagic.Controller();

  // Scene 1 Pinning
  let pinScene1 = new ScrollMagic.Scene({
    triggerElement: '#loading',
    triggerHook: 0,
    duration: '200%'
  })
  /* .addIndicators({
    name: 'pinscene1'
  }) */
  .setPin('#section1', {
    pushFollowers: false
  })
  .addTo(controller);


  // Scene 1 - tweening
  let tl1 = gsap.timeline();
  tl1.from('.section1__plechovka', {
      scale: 0.2,
      duration: 1
    })
    .set(".section1__logo", {
      className: "section1__logo visible"
    })
    .addPause(1)
    .set(".scrolldown", {
      className: "scrolldown scrolldown--side"
    })
    .addPause(2);

  let scene1 = new ScrollMagic.Scene({
    triggerElement: '#loading',
    //duration: '180%',
    duration: '100%',
    triggerHook: 0,
  })
  /* .addIndicators({
    name: 'tweenscene1'
  }) */
  .setTween(tl1)
  .addTo(controller);


  // Scene 1 - cutting: While cut scene is active, apply clip-path on section 1
  let cutScene2 = new ScrollMagic.Scene({
      triggerElement: '#section2',
      triggerHook: 1,
      duration: '200%',
      reverse: true
    })
    /* .addIndicators({
      name: 'cutScene2'
    }) */
    .setClassToggle('#agecheck + .scrollmagic-pin-spacer', 'spacer--clipped')
    .addTo(controller);


  // Scene 2 - videoplay
  let videoScene2 = new ScrollMagic.Scene({
      triggerElement: '#section2',
      triggerHook: 0.75,
      duration: '75%',
      reverse: true
    })
    .on('start', function (event) {
      if (typeof(window.playVideo) !== 'function') return;

      if (event.scrollDirection == 'FORWARD') {
        window.playVideo();
      } else {
        window.pauseVideo();
      }
    })
    .on('end', function (event) {
      if (typeof (window.playVideo) !== 'function') return;

      if (event.scrollDirection == 'FORWARD') {
        window.pauseVideo();
      } else {
        window.playVideo();
      }
    })
    /* .addIndicators({
      name: 'videoscene2'
    }) */
    .addTo(controller);




  // Scene 2 - video out
  let scene2videoOut = new ScrollMagic.Scene({
      triggerElement: '#section2',
      triggerHook: 0,
      duration: '150%'
    })
    .setTween(
      gsap.to('.section2__video', {
        y: '-100%',
        duration: 1
      })
    )
    /* .addIndicators({
      name: 'scene2videoOut'
    }) */
    .addTo(controller);

  // Scene 2 - tweening
  let tl2 = gsap.timeline();
  let pinScene2;
  let scene2;

  // Scene 2 - pinning
  pinScene2 = new ScrollMagic.Scene({
      triggerElement: '#section2',
      triggerHook: 0,
      duration: '400%'
    })
    /* .addIndicators({
      name: 'pinscene2'
    }) */
    .setPin('#section2', {
      pushFollowers: true
    })
    .addTo(controller);


  scene2 = new ScrollMagic.Scene({
      triggerElement: '#section2',
      duration: '300%',
      triggerHook: 0,
    })
    /* .addIndicators({
      name: 'tweenscene2'
    }) */
    .setTween(tl2)
    .addTo(controller);


  installMediaQueryWatcher("(max-width: 48rem)", function (matches) {
    // Always clear the timeline for safety sake
    tl2.clear();
    // Clear any already present GSAP-created inline rules
    gsap.set(['.section2__lahevinner', '.section2__lahev', '#s2__je', '#s2__to', '#s2__lezak', '.textwrap_front__1', '#s2__prvni', '#s2__horky', '#s2__zbudvaru', '.section2__stripe', '.section2__lahevwrap', '.section2__textwrap'], {
      clearProps: 'all'
    });

    if (matches) {
      pinScene2.duration('400%');
      scene2.duration('300%');

      tl2.addPause(1)
        .to('.section2__lahevinner', {
          rotate: '90deg',
          duration: 1
        })
        .to('.section2__lahev', {
          scale: 1.5,
          duration: 1
        }, '-=0')
        .to('.section2__lahevinner', {
          x: '-145%',
          duration: 1
        }, '-=1')
        .set('#s2__je', {
          autoAlpha: 1
        })
        .set('#s2__to', {
          autoAlpha: 1
        }, '+=1')
        .set('#s2__lezak', {
          autoAlpha: 1
        }, '+=1')
        .set('.textwrap_front__1', {
          autoAlpha: 0
        }, '+=1')
        .call(() => {
          document.querySelector('#s2__lezak').classList.toggle('lezak--respomove');
          document.querySelector('#s2__lezak').classList.toggle('lezak--respohide');
        })
        .set('#s2__prvni', {
          autoAlpha: 1
        })
        .set('#s2__horky', {
          autoAlpha: 1
        }, '+=1')
        .set('#s2__lezak', {
          color: '#9C9C9C',
          autoAlpha: 1
        }, '+=1')
        .call(() => {
          document.querySelector('#s2__lezak').classList.toggle('lezak--respohide');
        })
        .call(() => {
          document.querySelector('#s2__zbudvaru').classList.toggle('zbudvaru--respomove');
        })
        .set('#s2__zbudvaru', {
          autoAlpha: 1
        }, '+=1')
        .addPause(1);

    } else {
      pinScene2.duration('700%');
      scene2.duration('600%');

      tl2.addPause(1)
        .to('.section2__lahevinner', {
          rotate: '90deg',
          duration: 1
        })
        .to('.section2__lahev', {
          scale: 1.5,
          duration: 1
        }, '-=0')
        .to('.section2__lahevinner', {
          x: '-145%',
          duration: 1
        }, '-=1')
        .set('#s2__je', {
          autoAlpha: 1
        })
        .set('#s2__to', {
          autoAlpha: 1
        }, '+=1')
        .set('#s2__lezak', {
          autoAlpha: 1
        }, '+=1')
        .set('.textwrap_front__1', {
          autoAlpha: 0
        }, '+=1')
        .call(() => {
          document.querySelector('#s2__lezak').classList.toggle('lezak--respomove');
          document.querySelector('#s2__lezak').classList.toggle('lezak--respohide');
        })
        .set('#s2__prvni', {
          autoAlpha: 1
        })
        .set('#s2__horky', {
          autoAlpha: 1
        }, '+=1')
        .set('#s2__lezak', {
          color: '#9C9C9C',
          autoAlpha: 1
        }, '+=1')
        .call(() => {
          document.querySelector('#s2__lezak').classList.toggle('lezak--respohide');
        })
        .call(() => {
          document.querySelector('#s2__zbudvaru').classList.toggle('zbudvaru--respomove');
        })
        .set('#s2__zbudvaru', {
          autoAlpha: 1
        }, '+=1')
        .addPause(1)
        .to('.section2__stripe', {
          x: '100%',
          duration: 9
        }, '+=1')
        .to('.section2__lahevwrap, .section2__textwrap', {
          autoAlpha: 0,
          duration: 3
        }, '-=8');
    }
  });


  // BEERCAN - pinning
  // get responsive gallery + productinfo duration
  let beercanPinDuration = 0;

  function getBeercanPinDuration() {
    //console.log('get duration', beercanPinDuration);
    return beercanPinDuration;
  }

  function setBeercanPinDuration() {
    let vh = document.documentElement.clientHeight || 0;

    setTimeout(() => {
      beercanPinDuration =
        document.getElementById('section3').offsetHeight
        + document.getElementById('section4').offsetHeight
        + document.getElementById('product-info').offsetHeight
        + vh/2;
    }, 200);

    //console.log('set duration', beercanPinDuration);
  }

  setBeercanPinDuration();

  window.addEventListener('resize', debounce(() => setBeercanPinDuration(), 200, false), false);
  window.addEventListener('orientationchange', () => setBeercanPinDuration(), false);

  let maskTl3 = gsap.timeline();

  maskTl3
    .addPause(1)
    /* .set("#section3", {
      className: "section--fullheight section--hcenter pinned"
    }) */
    .call(() => {
      document.querySelector('#section3').classList.toggle('pinned');
    })
    .addPause(8)
    /* .set("#section3", {
      className: "section--fullheight section--hcenter"
    }, 0.01) */
    .call(() => {
      document.querySelector('#section3').classList.toggle('pinned');
    })
    .addPause(1);


  let pinScene3 = new ScrollMagic.Scene({
      triggerElement: '#section3',
      duration: getBeercanPinDuration,
      triggerHook: 1,
    })
    /* .addIndicators({
      name: 'BEERCAN'
    }) */
    .setPin('#section3', {
      pushFollowers: false
    })
    .addTo(controller);


  let maskScene3 = new ScrollMagic.Scene({
      triggerElement: '#section3',
      duration: getBeercanPinDuration,
      triggerHook: 1,
    })
    /* .addIndicators({
      name: 'BEERCAN MASK'
    }) */
    .setTween(maskTl3)
    .addTo(controller);

  // Scene 3 - tweening
  let tl3 = gsap.timeline();

  tl3.addPause(0.5)
    .call(() => {
      document.querySelector('.section3__plechovka').classList.toggle('visible');
    })
    //.addPause(1)
    .to('.section3__plechovka', {
      scale: '1.05',
      y: '-3%',
      duration: 1
    })
    .to('.section3__plechovka', {
      rotate: 90,
      y: '12rem',
      duration: 1
    }, '-=0')
    .addPause(3);


  let scene3 = new ScrollMagic.Scene({
      triggerElement: '.gallery__end',
      duration: '100%',
      triggerHook: 1,
      reverse: true
    })
    /* .addIndicators({
      name: 'CAN ANIMATION'
    }) */
    .setTween(tl3)
    .addTo(controller);


  // Scene 4 - gallery visibility
  let scene4gallery = new ScrollMagic.Scene({
    triggerElement: '#section3',
    duration: '150%',
    triggerHook: 0.5,
  })
  /* .addIndicators({
    name: 'GALLERY VISIBILITY'
  }) */
  .setClassToggle('.section4__gallerywrap', 'gallery--visible')
  .addTo(controller);


  // Scene 4 - gallery pinning on desktop
  let pinScene4 = new ScrollMagic.Scene({
      triggerElement: '#section4',
      duration: '100%',
      triggerHook: 1,
    })
    /* .addIndicators({
      name: 'GALLERY PIN'
    }) */
    .setPin('#section4', {
      pushFollowers: false
    })
    .addTo(controller);


  let galleryPinned = true;

  function setGalleryPin() {
    let vw = document.documentElement.clientWidth || 0,
        galleryWillPinned = true;

    if (vw < remToPx(36)) { //36rem
      galleryWillPinned = false;
    }

    if (galleryPinned !== galleryWillPinned) {
      if (galleryWillPinned) {
        pinScene4.setPin('#section4', {
          pushFollowers: false
        });
        //console.log('pin set');

      } else {
        pinScene4.removePin(true);
        //console.log('pin removed');
      }

      galleryPinned = galleryWillPinned;
    }
  }

  setGalleryPin();

  window.addEventListener('resize', debounce(() => setGalleryPin(), 200, false), false);
  window.addEventListener('orientationchange', () => setGalleryPin(), false);





  // Scroll up + hide scrolldown
  let tlScrollup = gsap.timeline();

  tlScrollup.set('.scrolldown', {
      className: 'scrolldown scrolldown--side'
    }, 0.1)
    .set('.scrolldown', {
      className: 'scrolldown scrolldown--side scrolldown--static'
    }, 0.2)
    .to('.scrollup-btn', {
      y: '0',
      autoAlpha: 1,
      duration: 1
    });


  let scrollupScene = new ScrollMagic.Scene({
      triggerElement: '#budvar-33',
      duration: '25%',
      triggerHook: 0.5,
      reverse: true
    })
    /* .addIndicators({
      name: 'SCROLLUP'
    }) */
    .setTween(tlScrollup)
    .addTo(controller);


  // Static INTRO
  let staticIntroScene = new ScrollMagic.Scene({
      triggerElement: '#budvar-33',
      duration: '100%',
      triggerHook: 0.66,
      reverse: false
    })
    /* .addIndicators({
      name: 'STATIC INTRO'
    }) */
    .setTween(gsap.set('#budvar-33', {
      className: 'section--hcenter staticintro--loaded'
    }))
    .addTo(controller);


  // Perex
  let perexScene = new ScrollMagic.Scene({
      triggerElement: '.budvar__perex',
      duration: '100%',
      triggerHook: 0.75,
      reverse: false
    })
    /* .addIndicators({
      name: 'PEREX'
    }) */
    .setTween(gsap.set('.budvar__perex', {
      className: 'budvar__perex perex--loaded'
    }))
    .addTo(controller);


  // Hdl highlight
  let hdlHighlightScene = new ScrollMagic.Scene({
      triggerElement: '.info__textwrap',
      duration: '100%',
      triggerHook: 0.75,
      reverse: false
    })
    /* .addIndicators({
      name: 'PEREX'
    }) */
    .setTween(gsap.set('.info__textwrap .hdl--highlightinline', {
      className: 'hdl hdl--sm hdl--highlightinline hdl--highlightloaded'
    }))
    .addTo(controller);




  // Badges rotation
  /* let perexBadgeScene = new ScrollMagic.Scene({
      triggerElement: '.perex__badge',
      duration: '200%',
      triggerHook: 1,
      reverse: true
    })
    /* .addIndicators({
      name: 'PEREX'
    }) *
    .setTween(gsap.to('.perex__badge .badge__img', {
      rotate: '360deg',
      duration: 1
    }))
    .addTo(controller); */


  let transparentBadgeScene = new ScrollMagic.Scene({
      triggerElement: '.info__badge',
      duration: '200%',
      triggerHook: 1,
      reverse: true
    })
    /* .addIndicators({
      name: 'PEREX'
    }) */
    .setTween(gsap.to('.info__badge .badge__img', {
      rotate: '-180deg',
      duration: 1
    }))
    .addTo(controller);


  // SCENE { reverse: false }
  //.setClassToggle('#project', 'fade-in')







  /********
   *********   GALLERY
   ********/

  let galleryItems = document.querySelectorAll('.gallery__item'),
      gifSize = ''; //-lq, based on resolution

  function getGifSize() {
    let vw = document.documentElement.clientWidth || 0,
        ppx = window.devicePixelRatio || undefined,
        newGifSize;

    if (vw < 600) {
      newGifSize = 'sm';
    } else if (vw > 1366) {
      newGifSize = 'lg';
    } else {
      newGifSize = 'md';
    }

    if (gifSize !== newGifSize) {
      // check lazyloaded and their resolution - in case its lower, fetch new
      for (const galleryItem of galleryItems) {
        if (galleryItem.classList.contains('gallery__item--lazyloaded')) {
          let gif = galleryItem.querySelector('.item__gif'),
              sources = gif.querySelectorAll('source');

          // only load new videos when old ones are in lower resolution
          if (( newGifSize == 'lg' &&
              (gif.getAttribute('loaded-size') == 'sm' || gif.getAttribute('loaded-size') == 'md')
            ) || newGifSize == 'md' && (
              (gif.getAttribute('loaded-size') == 'sm')
            )) {
            for (const source of sources) {
              source.setAttribute('src', source.getAttribute('data-src-' + newGifSize));
            }
            gif.load();
            gif.setAttribute('loaded-size', newGifSize);
          }
        }
      }

      gifSize = newGifSize;
    }
  };
  getGifSize();

  window.addEventListener('resize', debounce(() => getGifSize(), 200, false), false);
  window.addEventListener('orientationchange', () => getGifSize(), false);



  for (const galleryItem of galleryItems) {
    let gif = galleryItem.querySelector('.item__gif'),
        sources = gif.querySelectorAll('source');

    galleryItem.addEventListener('mouseenter', (e) => {
      clearTimeout(galleryItem.mouseleave);
      galleryItem.mouseleave = undefined;

      if (galleryItem.classList.contains('gallery__item--lazyloaded')) {
        gif.play();

      } else {
        // lazyload
        galleryItem.lazyload = setTimeout(() => {
          loadGif(gif);

        }, 300);
      }
    });

    galleryItem.addEventListener('mouseleave', (e) => {
      clearTimeout(galleryItem.lazyload);

      if (!galleryItem.mouseleave) {
        galleryItem.mouseleave = setTimeout(()=> {
          gif.pause();
          galleryItem.mouseleave = undefined;
        }, 1000);
      }
    });
  }

  let galleryTouched = 0;

  function incrementTouched() {
    galleryTouched++;
    document.querySelector('.gallery__counter p').setAttribute('data-touched', galleryTouched);
  }

  function loadGif(gif, loadGifSize = gifSize, gallery = true) {
    let sources = gif.querySelectorAll('source');

    for (const source of sources) source.setAttribute('src', source.getAttribute('data-src-' + loadGifSize));
    gif.load();

    gif.setAttribute('loaded-size', loadGifSize);

    if (gallery) {
      gif.closest('.gallery__item').classList.add('gallery__item--lazyloaded');
      incrementTouched();
    }

    gif.play();
  }


  let gifObserverOptions = {
    threshold: 0.5
  };

  let gifObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadGif(entry.target);
      } else {
        entry.target.pause();
      }
    })

  }, gifObserverOptions);




  let gifObserved = false;

  function gifObserverInit() {
    let vw = document.documentElement.clientWidth || 0,
        gifWillObserved = vw < remToPx(36); // 36 rem

    if (gifObserved !== gifWillObserved) {
      if (gifWillObserved === true) {
        document.querySelectorAll('.item__gif').forEach((item) => {
          gifObserver.observe(item);
        });
      } else {
        document.querySelectorAll('.item__gif').forEach((item) => {
          gifObserver.unobserve(item);
        });
      }

      gifObserved = gifWillObserved;
    }
  }

  gifObserverInit();
  window.addEventListener('resize', debounce(() => gifObserverInit(), 200, false), false);
  window.addEventListener('orientationchange', () => gifObserverInit(), false);

  setBeercanPinDuration();


  /********
   *********   GIF LAZYLOADING OUTSIDE OF GALLERY
   ********/
  let gifStripeObserverOptions = {
    threshold: 0.1
  };

  let gifStripeObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadGif(entry.target, 'lg', false);
      } else {
        entry.target.pause();
      }
    })

  }, gifStripeObserverOptions);



   document.querySelectorAll('.other__gif').forEach((item) => {
     gifStripeObserver.observe(item);
   });


  /********
   *********   GIF LAZYLOADING OUTSIDE OF GALLERY
  ********/
  var halfScrolled = false,
      ticking = false;

  // half page scrolled throttled evt
  window.addEventListener('scroll', function (e) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY >= (document.body.scrollHeight - window.innerHeight) / 2 && halfScrolled === false) {
          var t = document.createElement('img');
          t.style = "visibility: hidden; width: 0; height: 0;";
          t.src = "https://secure.adnxs.com/px?id=1077348&seg=17051480&t=2";
          $('body').append(t);
          halfScrolled = true;
        }

        ticking = false;
      });
      ticking = true;
    }
  });

  setTimeout(function () {
    var t = document.createElement('img');
    t.style = "visibility: hidden; width: 0; height: 0;";
    t.src = "https://secure.adnxs.com/px?id=1077353&seg=17051539&t=2";
    $('body').append(t);
  }, 10000);

});